import React, { useEffect } from 'react';
import { translate } from 'translations/i18n';
import { Field } from 'formik';
import styled from 'styled-components';
import { gql, useQuery } from '@apollo/client';
import { camelCase } from 'lodash';
import { ChevronDown } from 'components/shared/DesignSystem/Icons';
import { Steven } from 'helpers/steven';

const INDUSTRIES_QUERY = gql`
  query DefaultIndustries {
    defaultIndustries {
      __typename
      id
      databaseId
      name
    }
  }
`;

const IconWrapper = styled.div`
  margin-right: 6px;
`;

const Industry = () => {
  // this is the event fired from desktop web when accepting a collaboration
  useEffect(() => {
    Steven.signupStep({
      step_name: 'view_gather_trade',
    });
  }, []);

  const { data, loading } = useQuery(INDUSTRIES_QUERY);
  const defaultIndustries = data?.defaultIndustries ?? [];
  const industryOptions = [
    {
      name: translate('onboard.signUp.industry.selectOne'),
      id: '',
      disabled: true,
    },
    ...defaultIndustries,
  ];

  return (
    <div className="form-field">
      <div className="input-wrap ">
        <div className="input-wrap input-wrap--withicon">
          <Field
            as="select"
            name="industry"
            className="select-new-signup"
            disabled={loading}
            data-testid="signup__industry"
          >
            {industryOptions.map((option) => (
              <option
                key={option.id}
                value={option.id}
                disabled={option.disabled}
                data-testid={`signup__industry-${camelCase(option.name)}`}
              >
                {option.name}
              </option>
            ))}
          </Field>
          <label htmlFor="industry">
            {translate('onboard.signUp.industry.label')}
          </label>
          <IconWrapper>
            <ChevronDown size={20} color="#707B86" />
          </IconWrapper>
        </div>
      </div>
    </div>
  );
};

export default Industry;
